export class ViewStateFilterVisibility {
    public static HIDDEN = 1;
    public static VISIBLE = 2;
    public static NONE = 3;
}
